import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appImgPlaceholder]'
})
export class ImgPlaceholderDirective {
  @Input() appImgPlaceholder;

  constructor(
    private ele: ElementRef
  ) {
    if (!ele.nativeElement.getAttribute('src')) {
      ele.nativeElement.setAttribute('src', this.appImgPlaceholder);
    }

    ele.nativeElement.onerror = () => {
      ele.nativeElement.setAttribute('src', this.appImgPlaceholder);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/img-placeholder.directive.ts